import { useEffect,useState } from 'react'
import { get,post } from '../lib/api'
import { mt } from '../lib/i18n'

interface Flag{itemId:string;title:string;snippet:string}
/** For the team: listings sent for review under Other. A pile of the same kind of thing means a topic should be added. */
export default function CategoryIdeas(){
 const [flags,setFlags]=useState<Flag[]>([])
 const load=()=>{get<{flags:Flag[]}>('/api/market/category-flags').then(r=>setFlags(r.flags)).catch(()=>setFlags([]))}
 useEffect(load,[])
 if(!flags.length)return null
 return <details className="review-section cat-ideas"><summary>{mt('catIdeasTitle')} <b>{flags.length}</b></summary><p>{mt('catIdeasNote')}</p>
  {flags.map(f=><article key={f.itemId} className="cat-idea"><div><strong>{f.title}</strong><small>{f.snippet}</small></div><button className="market-button secondary" onClick={()=>{void post(`/api/market/category-flags/${f.itemId}`,{}).then(load)}}>{mt('catIdeasDone')}</button></article>)}
 </details>
}
